import { createErrorFrom, fetchProfileData, FxIdApplicationStoreCreatePaymentHandlerEmbeddingType, FxIdDomainEntitiesAghanimPaymentStatus, FxIdDomainEntitiesPlutusPaymentStatus, FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus, FxIdDomainStoreEnumsSupportedWebPublishingPlatform, openApiConfig } from "@fxid/openapi-client";
import OpenApiClient from "@fxid/openapi-client";
import { EFxIdSdkAdapterInfoSocialCapability, FxIdSdkAdapterSocialSettingDefault } from "@fxid/sdk-core";
import log, { appStore, errorToString, getAuthToken } from "@fxid/shared";
import { closeModal } from "@mantine/modals";
import i18next from "i18next";
import { ok, telegram, vk } from "vanilla-sharing";
import { waitForAghanimPayment, waitForPlutusPayment } from "../helpers/aghanimPaymentHelper";
import { deferred } from "../types/FxIdSdkUtils";
import { FxIdSdkBaseAdapter } from "./FxIdSdkBaseAdapter";
const FxIdSdkIframeModalClosedEvent = "FxIdSdkIframeModalClosedEvent";
export class FxIdSdkAdapterForFxId extends FxIdSdkBaseAdapter {
    constructor(exportedSdk, game, config, dependencies) {
        super(exportedSdk, game, config, dependencies);
        this.exportedSdk = exportedSdk;
        this.game = game;
        this.config = config;
        this.adapter = "fxid";
        this.defaultSocialSettings = {
            ...FxIdSdkAdapterSocialSettingDefault,
            ui: {
                ...FxIdSdkAdapterSocialSettingDefault.ui,
                disabled: false
            }
        };
        this.paymentIsSuccessful = false;
        this.yandexAdsLoaded = false;
    }
    async RegisterShareHandlers() {
        const sharingHandler = this._dependencies.getSharingHandler();
        const data = { url: window.location, title: i18next.t(`seo.${this.game}.title`) };
        if (sharingHandler) {
            sharingHandler.enableShareVk?.(() => vk(data));
            sharingHandler.enableShareOk?.(() => ok(data));
            sharingHandler.enableShareTelegram?.(() => telegram(data));
            sharingHandler.enableLinkCopy?.(() => {
            });
        }
        /*
         * TODO: Или переместить в более логичное место или переименовать метод, чтобы можно было подобные подвязыки
         * включать туn
         */
        appStore.getState().enableWebPlayLogin();
        const profileData = await fetchProfileData(this.game);
        const userDisplayName = profileData.Name ?? profileData.Email ?? `#${profileData.AccountId}`;
        this._dependencies.setUserId(String(profileData.AccountId));
        this._dependencies.setUserDisplayName(userDisplayName);
        return Promise.resolve();
    }
    async BuyProduct(request) {
        try {
            return await this.StartBuyProduct(request);
        }
        catch (error) {
            log.error("Error while processing BuyProduct", error);
            throw createErrorFrom(error);
        }
    }
    async StartBuyProduct(request) {
        const paymentRequest = {
            Token: getAuthToken(),
            Game: this.game,
            Sku: request.sku,
            WebPublishingPlatform: FxIdDomainStoreEnumsSupportedWebPublishingPlatform.FxId,
            EmbeddingType: FxIdApplicationStoreCreatePaymentHandlerEmbeddingType.Embed,
            ProductDescriptionHint: request.productDescriptionHint,
            ProductNameHint: request.productNameHint
        };
        if (request.developerPayload != null) {
            paymentRequest.DeveloperPayload = {
                MerchantDeveloperPayload: request.developerPayload
            };
        }
        const createPaymentResult = await OpenApiClient.Store.fxIdWebFeaturesStoreCreatePaymentEndpoint(paymentRequest);
        await this._dependencies.handlePersonalInfoRequirements(createPaymentResult);
        log.info("Received result from server: %o", createPaymentResult);
        return this.StartPayment(createPaymentResult);
    }
    StartPayment(createPaymentResult) {
        const { promise, resolve, reject } = deferred();
        this.buyProductResolve = async (data) => {
            log.info("Buy product resolved %o", data);
            try {
                await OpenApiClient.Store.fxIdWebFeaturesStoreOrdersSetOptimisticOrderStatusSetOptimisticOrderStatusEndpoint({
                    PublicOrderId: createPaymentResult.TransactionId,
                    Status: FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus.Completed
                });
            }
            catch (e) {
                log.error("Failed to set optimistic status:", e);
            }
            resolve({
                ...data,
                transactionId: createPaymentResult.TransactionId,
                stats: {
                    currency: createPaymentResult.OrderProduct.Currency ?? "",
                    currencyAmount: createPaymentResult.OrderProduct.Price ?? 0,
                    usdAmount: createPaymentResult.OrderProduct.UsdPrice ?? 0
                }
            });
        };
        this.buyProductReject = async (data) => {
            log.error("Buy product rejected %o", data);
            try {
                await OpenApiClient.Store.fxIdWebFeaturesStoreOrdersSetOptimisticOrderStatusSetOptimisticOrderStatusEndpoint({
                    PublicOrderId: createPaymentResult.TransactionId,
                    Status: FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus.Cancelled
                });
            }
            catch (e) {
                log.error("Failed to set optimistic status:", e);
            }
            reject(new Error(errorToString(data)));
        };
        this.currentPublicOrderId = createPaymentResult.TransactionId;
        // Предполагаем что всегда есть на FxId
        const xsollaPaymentResult = createPaymentResult.Xsolla;
        const yookassaPaymentResult = createPaymentResult.Yookassa;
        const stripePaymentResult = createPaymentResult.Stripe;
        const moneyMailRuResult = createPaymentResult.MoneyMailRu;
        const aghanimResult = createPaymentResult.Aghanim;
        const plutusResult = createPaymentResult.Plutus;
        if (xsollaPaymentResult != null) {
            this.StartXsollaPayment(xsollaPaymentResult, createPaymentResult);
        }
        else if (yookassaPaymentResult != null) {
            this.StartYookassaPayment(yookassaPaymentResult, createPaymentResult);
        }
        else if (stripePaymentResult != null) {
            void this.StartStripePayment(stripePaymentResult, createPaymentResult);
        }
        else if (moneyMailRuResult != null) {
            this.StartMoneyMailRuPayment(moneyMailRuResult, createPaymentResult);
        }
        else if (aghanimResult != null) {
            void this.StartAghanimPayment(aghanimResult, createPaymentResult);
        }
        else if (plutusResult != null) {
            void this.StartPlutusPayment(plutusResult, createPaymentResult);
        }
        else {
            throw new Error("Unsupported payment method for FxId web");
        }
        return promise;
    }
    StartYookassaPayment(yookassaPaymentResult, createPaymentResult) {
        if (yookassaPaymentResult.Redirect && yookassaPaymentResult.ConfirmationUrl) {
            window.open(yookassaPaymentResult.ConfirmationUrl, "_blank", "noopener,noreferrer");
            this.buyProductResolve?.call(this, "[YOOKASSA] Yookassa configured with redirect. Returning immediately");
            return;
        }
        if (yookassaPaymentResult.ConfirmationToken) {
            const confirmation_token = yookassaPaymentResult.ConfirmationToken;
            if (!window.YooMoneyCheckoutWidget) {
                this.buyProductReject?.call(this, "[YOOKASSA] No Yoomoney widget in window!");
                return;
            }
            const checkout = new window.YooMoneyCheckoutWidget({
                confirmation_token,
                error_callback: log.error,
                customization: {
                    modal: true
                }
            });
            checkout.on("success", () => {
                log.info("[YOOKASSA] Yookassa payment successful!");
                this.buyProductResolve?.call(this, { transactionId: createPaymentResult.TransactionId });
            });
            checkout.on("complete", () => checkout.destroy());
            checkout.on("fail", () => {
                log.info("[YOOKASSA] Payment failed for some reason!");
                this.buyProductReject?.call(this, "Payment failed for some reason!");
            });
            checkout.on("modal_close", () => {
                log.info("[YOOKASSA] Widget closed before payment completed");
                this.buyProductReject?.call(this, "Widget closed before payment completed");
            });
            void checkout.render();
            return;
        }
        throw new Error("[YOOKASSA] No data for Yookassa payment");
    }
    StartXsollaPayment(xsollaData, createPaymentResult) {
        this.paymentIsSuccessful = false;
        if (!window.XPayStationWidget)
            throw new Error("No Xsolla widget in window!");
        // https://github.com/xsolla/paystation-embed
        // На мобилках xsolla виджет работает не правильно, поэтому там открывается айфрейм с платежным урлом
        if (this.exportedSdk.IsMobile()) {
            log.info("[XSOLLA] Opening Xsolla in iframe with url:", xsollaData.ConfirmationUrl);
            this._dependencies.openIframeModal({
                url: xsollaData.ConfirmationUrl,
                onClose: () => postMessage({ cmd: FxIdSdkIframeModalClosedEvent }, "*"),
                fullScreen: true
            });
        }
        else {
            log.info("[XSOLLA] Initializing Xsolla widget");
            // https://github.com/xsolla/paystation-embed#widget-options
            const xsollaOptions = {
                access_token: xsollaData.PaymentToken,
                sandbox: xsollaData.Sandbox,
                // closeByClick и closeByKeyboard попросили CrazyGames у рбв
                // https://chat.rbwtech.net/rbw/pl/cwdojfr5kignmf7ybdseitejdh
                lightbox: {
                    closeByClick: false,
                    closeByKeyboard: false
                }
            };
            if (this.exportedSdk.IsMobile()) {
                xsollaOptions.childWindow = { target: "_parent" };
            }
            window.XPayStationWidget.init(xsollaOptions);
            log.info("[XSOLLA] Opening Xsolla widget with options: %o", xsollaOptions);
            window.XPayStationWidget.open();
        }
    }
    async GetSocialInfo() {
        const profileData = await fetchProfileData(this.game);
        return {
            social: FxIdDomainStoreEnumsSupportedWebPublishingPlatform.FxId,
            paymentsAvailable: true,
            userId: profileData.AccountId.toString(),
            capabilities: [EFxIdSdkAdapterInfoSocialCapability.AdsAvailable]
        };
    }
    async Initialize() {
        if (this.config.Store.XsollaEnabled) {
            // https://github.com/xsolla/paystation-embed
            // Не ждем
            void new Promise((resolve) => {
                const s = document.createElement("script");
                s.type = "text/javascript";
                s.src = `https://cdn.xsolla.net/embed/paystation/1.2.9/widget.min.js`;
                s.async = true;
                s.addEventListener("load", (e) => {
                    log.info("Xsolla widget loaded");
                    this.StartListenForXsollaEvents();
                    resolve();
                }, false);
                const head = document.getElementsByTagName("head")[0];
                head.appendChild(s);
                log.info("Xsolla script added");
            });
        }
        if (this.config.Store.YookassaEnabled) {
            void new Promise((resolve) => {
                const s = document.createElement("script");
                s.type = "text/javascript";
                s.src = "https://yookassa.ru/checkout-widget/v1/checkout-widget.js";
                s.async = true;
                s.addEventListener("load", () => {
                    log.info("Yookassa widget loaded");
                    resolve();
                });
                const head = document.getElementsByTagName("head")[0];
                head.appendChild(s);
                log.info("Yookassa script added");
            });
        }
        void this.TryInitializeGoogleAds(this.config.PublicWebClientConfig);
        void this.TryInitializeYandexAds(this.config.PublicWebClientConfig);
        this.StartListenToMoneyMailRuEvents();
        return Promise.resolve();
    }
    StoreCurrency() {
        return Promise.resolve(undefined);
    }
    StatInitialize(request) {
        return Promise.resolve();
    }
    StatEvent(request) {
        return Promise.resolve(undefined);
    }
    AdsIsVideoReady() {
        log.info("[VIDEO ADS] Video Ads status requested");
        return Promise.resolve(window.googleVideoAdsReady ?? this.yandexAdsLoaded ?? false);
    }
    async AdsShowVideo() {
        log.info("[VIDEO ADS] Ad requested");
        if (!(await this.AdsIsVideoReady())) {
            log.warn("[VIDEO ADS] Ad requested when ads not yet ready");
            return;
        }
        if (this.yandexAdsLoaded) {
            this.AdsShowVideoYandex();
        }
        else {
            this.AdsShowVideoGoogle();
        }
    }
    StartListenForXsollaEvents() {
        const sendResult = (args) => {
            if (this.paymentIsSuccessful) {
                log.info("[XSOLLA] Widget closed after payment successfully completed. All is good", args);
                this.buyProductResolve?.call(this, {});
            }
            else {
                log.info("[XSOLLA] Widget closed before payment completed", args);
                this.buyProductReject?.call(this, "Payment widget closed before payment completed!");
            }
            if (!this.exportedSdk.IsMobile()) {
                window.XPayStationWidget.close();
            }
            closeModal("iframe");
        };
        const sendResultFromModalClosed = (args) => {
            if (this.paymentIsSuccessful) {
                log.info("Modal closed after payment successfully completed. All is good", args);
                this.buyProductResolve?.call(this, {});
            }
            else {
                log.info("Modal closed before payment completed", args);
                this.buyProductReject?.call(this, "Payment widget closed before payment completed!");
            }
            closeModal("iframe");
        };
        // https://developers.xsolla.com/doc/pay-station/features/paystation-analytics/#pay_station_features_analytics_ps_events
        window.addEventListener("message", (_event) => {
            if (_event.origin === "https://secure.xsolla.com" ||
                _event.origin === "https://sandbox-secure.xsolla.com") {
                log.info("Event from Xsolla: %o", _event);
                const event = JSON.parse(_event.data);
                if (event.command === "return") {
                    // Clicking the Return to Store/Start again button.
                    sendResult(event);
                    if (!this.exportedSdk.IsMobile()) {
                        window.XPayStationWidget.close();
                    }
                    closeModal("iframe");
                }
                else if (event.command === "status") {
                    if (event.data.paymentInfo.status === "done") {
                        // Changing the order status to done. The event is sent from the payment status page if an order was created via one of the following API calls
                        this.paymentIsSuccessful = true;
                        sendResult(event);
                        if (!this.exportedSdk.IsMobile()) {
                            window.XPayStationWidget.close();
                        }
                        closeModal("iframe");
                    }
                    else {
                        log.info("Status: %o", event.data.paymentInfo.status);
                    }
                }
            }
            if (typeof _event.data === "object") {
                if (_event.data.cmd === FxIdSdkIframeModalClosedEvent) {
                    log.info("Modal closed");
                    sendResultFromModalClosed(_event.data);
                }
            }
        });
        // В мобильном варианте, когда иксола открывается в айфрейме, может и не быть виджета
        if (window.XPayStationWidget == null) {
            log.error("Can't listen for xsolla events - window.XPayStationWidget is null");
            return;
        }
        window.XPayStationWidget.on(window.XPayStationWidget.eventTypes.STATUS_DONE, (...args) => {
            log.info("[XSOLLA] Xsolla payment successful!", args);
            this.paymentIsSuccessful = true;
            // Тут просто запоминается состояние что платеж завершен
            // сам эвент отправится в CLOSE
            // т.е. в этот момент платежка еще открыта и если слать сразу resolve
            // то игры будут показывать анимацию под платежкой
            // resolve({ transactionId: createPaymentResult.TransactionId });
        });
        window.XPayStationWidget.on(window.XPayStationWidget.eventTypes.CLOSE, (...args) => {
            log.info("[XSOLLA] 'close' event");
            sendResult(args);
        });
        window.XPayStationWidget.on(window.XPayStationWidget.eventTypes.CLOSE_WIDGET, (...args) => {
            log.info("[XSOLLA] 'close-widget' event");
            sendResult(args);
        });
        window.XPayStationWidget.on(window.XPayStationWidget.eventTypes.RETURN, (...args) => {
            log.info("[XSOLLA] 'return' event");
            sendResult(args);
        });
    }
    async InviteFriends() {
        const profileData = await fetchProfileData(this.game);
        // HACK: У нас нет способа забрать из OpenApiClient точный путь до эндпоинта с редиректом, поэтому собираем его
        // руками и надеемся, что все не сломается
        const redirectUrl = new URL(`${openApiConfig.basePath}/api/v1/go`);
        redirectUrl.searchParams.append("fxref", String(profileData.AccountId));
        redirectUrl.searchParams.append("url", window.location.toString());
        this._dependencies.openLinkShareModal({ link: redirectUrl.toString() });
        return { friends: [] };
    }
    async StartStripePayment(stripePaymentResult, createPaymentResult) {
        this.paymentIsSuccessful = false;
        let paymentCompleted = false;
        const stripeOptions = createPaymentResult.Stripe;
        if (stripeOptions == null)
            throw new Error("Stripe not in result");
        // openIframeModal({ url: stripePaymentResult.SessionUrl });
        // window.open(stripePaymentResult.SessionUrl, "_blank");
        const profileData = await fetchProfileData(this.game);
        this._dependencies.openStripeCheckoutModal({
            paymentSecret: stripePaymentResult.SessionClientSecret,
            publishableKey: stripePaymentResult.PublishableKey,
            returnUrl: window.location.href,
            email: profileData.Email,
            onClose: () => {
                if (!paymentCompleted) {
                    if (this.paymentIsSuccessful) {
                        this.buyProductResolve?.call(this, {});
                    }
                    else {
                        this.buyProductReject?.call(this, "Unknown error");
                    }
                }
            },
            onCompleted: () => {
                this.paymentIsSuccessful = true;
                paymentCompleted = true;
                this.buyProductResolve?.call(this, {});
            },
            onError: (message) => {
                paymentCompleted = true;
                this.buyProductReject?.call(this, message);
            }
        });
        // this.buyProductResolve?.call(this, {});
    }
    StartListenToMoneyMailRuEvents() {
        const sendResultFromModalClosed = (eventData) => {
            if (this.paymentIsSuccessful) {
                log.info("MailRu payment already completed");
                return;
            }
            this.paymentIsSuccessful = true;
            if (eventData.action === "closeWindow" || eventData.action === "paySuccess") {
                this.buyProductResolve?.call(this, {});
            }
            else {
                this.buyProductReject?.call(this, eventData);
            }
        };
        window.addEventListener("message", (_event) => {
            if (_event.origin === "https://pay.my.com" ||
                _event.origin === "https://pw.money.mail.ru" ||
                _event.origin === "https://pay.my.games") {
                log.info("Event from Money.MailRu: %o", _event);
                try {
                    // Данные могут приходить как в виде строки (старый формат), так и в виде объекта (новый формат)
                    const event = typeof _event.data === "string" ? JSON.parse(_event.data) : _event.data;
                    // Тут эвенты от ДМР и от нового MoneyMail.Ru
                    if (event.action === "closeWindow" ||
                        event.action === "refreshWindow" ||
                        event.action === "paySuccess" ||
                        event.action === "payError") {
                        // Clicking the Return to Store/Start again button.
                        sendResultFromModalClosed(event);
                        closeModal("iframe");
                    }
                }
                catch (e) {
                    log.error("Failed to parse event", _event, e);
                    sendResultFromModalClosed({ eventData: { action: "payError" }, event: _event });
                    closeModal("iframe");
                }
            }
            if (typeof _event.data === "object") {
                if (_event.data.cmd === FxIdSdkIframeModalClosedEvent) {
                    log.info("MailRu Payment modal closed");
                    sendResultFromModalClosed(_event.data);
                }
            }
        });
    }
    StartMoneyMailRuPayment(moneyMailRuResult, createPaymentResult) {
        this.paymentIsSuccessful = false;
        this._dependencies.openIframeModal({
            url: moneyMailRuResult.PaymentUri,
            onClose: () => postMessage({ cmd: FxIdSdkIframeModalClosedEvent }, "*"),
            fullScreen: true
        });
    }
    async StartAghanimPayment(aghanimMerchantData, createPaymentResult) {
        this.paymentIsSuccessful = false;
        window.open(aghanimMerchantData.CheckoutUrl, "_blank");
        try {
            await this.startPollingPaymentStatus(createPaymentResult);
        }
        catch (error) {
            log.error("Error in Aghanim payment polling:", error);
            this.buyProductReject?.(error);
        }
    }
    async startPollingPaymentStatus(createPaymentResult) {
        try {
            const result = await waitForAghanimPayment(OpenApiClient.Store, createPaymentResult.TransactionId);
            if (result === FxIdDomainEntitiesAghanimPaymentStatus.Payed) {
                this.paymentIsSuccessful = true;
                this.buyProductResolve?.({
                    transactionId: createPaymentResult.TransactionId,
                    stats: {
                        currency: createPaymentResult.OrderProduct.Currency ?? "",
                        currencyAmount: createPaymentResult.OrderProduct.Price ?? 0,
                        usdAmount: createPaymentResult.OrderProduct.UsdPrice ?? 0
                    }
                });
            }
            else {
                this.buyProductReject?.("Payment not completed");
            }
        }
        catch (error) {
            log.error("Error in Aghanim payment polling:", error);
            this.buyProductReject?.(error);
        }
    }
    async startPollingPlutusPaymentStatus(createPaymentResult) {
        try {
            const result = await waitForPlutusPayment(OpenApiClient.Store, createPaymentResult.TransactionId);
            if (result === FxIdDomainEntitiesPlutusPaymentStatus.Payed) {
                this.paymentIsSuccessful = true;
                closeModal("iframe");
                this.buyProductResolve?.({
                    transactionId: createPaymentResult.TransactionId,
                    stats: {
                        currency: createPaymentResult.OrderProduct.Currency ?? "",
                        currencyAmount: createPaymentResult.OrderProduct.Price ?? 0,
                        usdAmount: createPaymentResult.OrderProduct.UsdPrice ?? 0
                    }
                });
            }
            else {
                this.buyProductReject?.("Payment not completed");
            }
        }
        catch (error) {
            log.error("Error in Plutus payment polling:", error);
            this.buyProductReject?.(error);
        }
    }
    SetGoogleVideoAdsRead() {
        log.info("[VIDEO ADS] googleVideoAdsReady invoked");
        window.googleVideoAdsReady = true;
        this.exportedSdk.DispatchAdsVideoAvailable();
    }
    async TryInitializeGoogleAds(publicConfig) {
        window.setGoogleVideoAdsReady = this.SetGoogleVideoAdsRead.bind(this);
    }
    async TryInitializeYandexAds(publicConfig) {
        if (publicConfig.Advertisement == null) {
            return;
        }
        if (publicConfig.Advertisement.Yandex == null) {
            return null;
        }
        window.yaContextCb = window.yaContextCb || [];
        log.info("[VIDEO ADS] Loading yandex ads");
        await new Promise((resolve, reject) => {
            const s = document.createElement("script");
            s.type = "text/javascript";
            s.src = `https://yandex.ru/ads/system/context.js`;
            s.setAttribute("crossorigin", "anonymous");
            s.async = true;
            s.addEventListener("load", (e) => {
                log.info("[VIDEO ADS] Yandex ads loaded");
                this.yandexAdsLoaded = true;
                this.exportedSdk.DispatchAdsVideoAvailable();
                resolve();
            }, false);
            const head = document.getElementsByTagName("head")[0];
            head.appendChild(s);
            log.info("Google ads added");
        });
    }
    AdsShowVideoGoogle() {
        if (typeof window.adBreak === "undefined") {
            log.warn("[VIDEO ADS] adBreak function not yet ready");
            return;
        }
        window.adBreak({
            type: "reward",
            name: "unknown",
            beforeAd: () => {
                log.info("[VIDEO ADS] Prepare for the ad. Mute and pause the game flow");
            },
            afterAd: () => {
                log.info("[VIDEO ADS] Resume the game and re-enable sound");
            },
            // Prepare for the ad. Mute and pause the game flow
            beforeReward: (showAdFn) => {
                log.info("[VIDEO ADS] Show reward prompt (call showAdFn() if clicked)");
                showAdFn();
            },
            adDismissed: () => {
                log.info("[VIDEO ADS] Player dismissed the ad before completion");
                this.exportedSdk.DispatchAdsSkipped();
            },
            adViewed: () => {
                log.info("[VIDEO ADS] Ad was viewed and closed");
                this.exportedSdk.DispatchAdsFinished();
            },
            adBreakDone: (placementInfo) => {
                log.info("[VIDEO ADS] Always called (if provided) even if an ad didn't show. PlacementInfo: %o", placementInfo);
                // Dismissed обрабатывается выше. Все остальное - ошибки
                if (placementInfo.breakStatus != "viewed" && placementInfo.breakStatus != "dismissed") {
                    this.exportedSdk.DispatchAdsFailed();
                }
            }
        });
    }
    AdsShowVideoYandex() {
        log.info("Showing yandex ad");
        const desktopBlock = this.config.PublicWebClientConfig.Advertisement?.Yandex?.Rewarded?.DesktopBlockId;
        const mobileBlock = this.config.PublicWebClientConfig.Advertisement?.Yandex?.Rewarded?.MobileBlockId;
        window.yaContextCb?.push(() => {
            log.info("Choosing yandex platform");
            if (window.Ya?.Context.AdvManager.getPlatform() === "desktop") {
                if (desktopBlock == null) {
                    log.warn("Desktop block is undefined for yandex rewarded video");
                    this.exportedSdk.DispatchAdsFailed();
                    return;
                }
                log.info("Showing yandex ad for desktop: %s", desktopBlock);
                // вызов блока Rewarded для десктопной версии
                window.Ya?.Context.AdvManager.render({
                    blockId: desktopBlock,
                    type: "rewarded",
                    platform: "desktop",
                    onRewarded: (isRewarded) => {
                        if (isRewarded) {
                            this.exportedSdk.DispatchAdsFinished();
                        }
                        else {
                            this.exportedSdk.DispatchAdsFailed();
                        }
                    }
                });
            }
            else {
                // вызов блока Rewarded для мобильной версии
                if (mobileBlock == null) {
                    log.warn("Mobile block is undefined for yandex rewarded video");
                    this.exportedSdk.DispatchAdsFailed();
                    return;
                }
                log.info("Showing yandex ad for mobile: %s", desktopBlock);
                window.Ya?.Context.AdvManager.render({
                    blockId: mobileBlock,
                    type: "rewarded",
                    platform: "touch",
                    onRewarded: (isRewarded) => {
                        if (isRewarded) {
                            this.exportedSdk.DispatchAdsFinished();
                        }
                        else {
                            this.exportedSdk.DispatchAdsFailed();
                        }
                    }
                });
            }
        });
    }
    async StartPlutusPayment(plutusResult, createPaymentResult) {
        this.paymentIsSuccessful = false;
        let modalClosedManually = false;
        let paymentConfirmed = false;
        this._dependencies.openIframeModal({
            url: plutusResult.PaymentUrl,
            onClose: () => {
                modalClosedManually = true;
                postMessage({ cmd: FxIdSdkIframeModalClosedEvent }, "*");
            },
            fullScreen: true
        });
        const waitForPaymentConfirmation = new Promise((resolve, reject) => {
            const closeHandler = (event) => {
                if (typeof event.data === "object" && event.data.cmd === FxIdSdkIframeModalClosedEvent) {
                    window.removeEventListener("message", closeHandler);
                    if (modalClosedManually && !paymentConfirmed) {
                        log.info("Modal closed, starting 5-second confirmation window");
                        const confirmationTimeout = setTimeout(() => {
                            if (!paymentConfirmed) {
                                reject(new Error("Payment not confirmed within 5 seconds"));
                            }
                        }, 5000);
                        const originalReject = this.buyProductReject;
                        this.buyProductReject = (error) => {
                            clearTimeout(confirmationTimeout);
                            originalReject?.(error);
                        };
                    }
                }
            };
            window.addEventListener("message", closeHandler);
        });
        try {
            await Promise.race([
                this.startPollingPlutusPaymentStatus(createPaymentResult),
                waitForPaymentConfirmation
            ]);
            paymentConfirmed = true;
            this.paymentIsSuccessful = true;
        }
        catch (error) {
            if (!this.paymentIsSuccessful) {
                log.error("Payment failed:", error);
                this.buyProductReject?.(error);
            }
        }
    }
}
